// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"4a2f773c","902":"20c39cde"}[chunkId] + ".chunk.js";
};